import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { BASE_URL } from './constant/BaseApiUrl';

export default class SubmitService {
  onSubmit(airInfo) {
    return axios.post(`${BASE_URL}${ApiKey.CREATE_QUOTE}`, airInfo);
  }
}
